import React, { useMemo, useState } from 'react';
import Logo from '@/assets/image/vip/logo.png';
import LogoWeb from '@/assets/image/vip/logo-web.png';
import LogoSingle from '@/assets/image/vip/logo-single.png';
import { getIncomeSource, getVipTag, isAppStorePay, isWeb } from '@/utils/vip';
import { getUrlParam } from '@/utils';
import { SubscribeType, isTeamSubscription, subscribeType, isFromPcHome } from '@/constants';
import classnames from 'classnames';
import ConsultationModal from '@/components/consultation-modal';
import { TabType } from '@/constants/subscription';
import { openVipComparePopup } from '@meitu/saas-subscription-popup/dist/esm/utils';
import { useAtom } from 'jotai';
import { curProductAtom, curTabAtom, userInfoAtom, vipInfoAtom } from '@/store';
import { track } from '@/utils/common';
import { getJumpQuery } from '@/utils/jumpQuery';
import MaterialVip from '@/assets/image/new/material-vip.png';
import MaterialVipEn from '@/assets/image/new/material-vip-en.png';
import MaterialPro from '@/assets/image/new/material-pro.png';
import MaterialProEn from '@/assets/image/new/material-pro-en.png';
import MaterialVipPc from '@/assets/image/new/material-vip-pc.png';
import MaterialProPc from '@/assets/image/new/material-pro-pc.png';
import MaterialMeidou from '@/assets/image/new/material-meidou.png';
import MaterialMeidouEn from '@/assets/image/new/material-meidou-en.png';
import MaterialTeamVip from '@/assets/image/new/material-team-vip.png';
import MaterialTeamVipEn from '@/assets/image/new/material-team-vip-en.png';
import MaterialTeamMeidou from '@/assets/image/new/material-team-meidou.png';
import MaterialTeamMeidouEn from '@/assets/image/new/material-team-meidou-en.png';
import MaterialCutout from '@/assets/image/new/material-cutout.png';
import MaterialCutoutEn from '@/assets/image/new/material-cutout-en.png';
import MaterialBatch from '@/assets/image/new/material-cutout.png';

import styles from './index.module.css';
import { useLocaleStore } from '@/i18n/localeStore';
import { getLanguage } from '@/i18n';

const Copywriting = () => {
  const { $t } = useLocaleStore();
  const [visible, setVisible] = useState<boolean>(false);
  const type = getUrlParam('type');

  const [curTab] = useAtom(curTabAtom);
  const [userInfo] = useAtom(userInfoAtom);
  const [vipInfo] = useAtom(vipInfoAtom);
  const [curProduct] = useAtom(curProductAtom);

  const materialUrl = useMemo(() => {
    // 内嵌批处理
    if (type === 'svip') {
      return MaterialBatch;
    }

    let url = null;
    switch (curTab) {
      case TabType.SUB:
        url = isTeamSubscription
          ? getLanguage() === 'zh-Hans'
            ? MaterialTeamVip
            : MaterialTeamVipEn
          : !isWeb || isFromPcHome
          ? MaterialVipPc
          : getLanguage() === 'zh-Hans'
          ? MaterialVip
          : MaterialVipEn;
        break;
      case TabType.PRO_SUB:
        url =
          !isWeb || isFromPcHome
            ? MaterialProPc
            : getLanguage() === 'zh-Hans'
            ? MaterialPro
            : MaterialProEn;
        break;
      case TabType.MEIDOU:
        url = isTeamSubscription
          ? getLanguage() === 'zh-Hans'
            ? MaterialTeamMeidou
            : MaterialTeamMeidouEn
          : getLanguage() === 'zh-Hans'
          ? MaterialMeidou
          : MaterialMeidouEn;
        break;
      case TabType.CUTOUT:
        url = getLanguage() === 'zh-Hans' ? MaterialCutout : MaterialCutoutEn;
        break;
      default:
        return MaterialVip;
    }
    return url;
  }, [curTab, isTeamSubscription, type]);

  const handleClick = () => {
    setVisible(true);
    track({
      event_id: 'vip_page_click',
      event_name: '会员落地页点击',
      params: {
        class: 'service',
      },
    });
  };

  return (
    <div className={classnames(styles.module)}>
      <div className={styles.materialBox}>
        <img className={styles.materialImg} src={materialUrl} alt="" />
        {/* {isTeamSubscription && curTab === TabType.SUB ? (
          <div
            className={styles.btn}
            onClick={() => {
              const jumpQuery = getJumpQuery();
              openVipComparePopup();
              const params = {
                class: 'view',
                name_id: curProduct?.productId,
                ...jumpQuery,
              };
              track({
                event_id: 'vip_page_click',
                event_name: '会员落地页点击',
                params,
              });
            }}
          >
            {$t((v) => v.Link_ViewBenefitDetail)}
          </div>
        ) : null} */}
      </div>
    </div>
  );
};

export default React.memo(Copywriting);
